var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { css, html, LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';
let QRPortalNotFoundView = class QRPortalNotFoundView extends LitElement {
    static get is() {
        return 'qr-portal-not-found-view';
    }
    static get styles() {
        return css `
            .container {
                text-align: center;
                font-size: 120%;
                margin: 60px 0;
            }
        `;
    }
    /** @override */ render() {
        return html `<div class="container">Not found</div>`;
    }
};
QRPortalNotFoundView._deps = [];
QRPortalNotFoundView = __decorate([
    customElement(QRPortalNotFoundView.is)
], QRPortalNotFoundView);
export { QRPortalNotFoundView };
